export const DECIMAL_PLACES = 1;